module.exports = __webpack_public_path__ + "img/FZ-background.ed62c03d.jpg";